import { Link } from "react-router-dom";
import { Instagram, Phone, Mail, MapPin } from "lucide-react";
import { BRAND } from "../data/menu";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-charred text-cream mt-32">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-6">
            <p className="text-[10px] uppercase tracking-[0.3em] text-cream/60 mb-5">Visit our trailer</p>
            <h2 className="font-serif text-7xl md:text-9xl leading-[0.85] tracking-tight">
              Old Soul<br />
              <span className="italic text-ember">Pizzeria.</span>
            </h2>
            <p className="mt-6 text-cream/70 text-sm tracking-[0.2em] uppercase">100 years of soul · 90 seconds on fire</p>
          </div>

          <div className="md:col-span-3 space-y-4">
            <p className="text-[10px] uppercase tracking-[0.3em] text-cream/60">Find us</p>
            <a href={BRAND.mapsUrl} target="_blank" rel="noreferrer" data-testid="footer-address"
               className="flex items-start gap-3 text-cream hover:text-ember transition-colors">
              <MapPin size={16} className="mt-1 shrink-0" />
              <span className="font-serif text-xl leading-snug">{BRAND.address}</span>
            </a>
            <a href={BRAND.phoneHref} data-testid="footer-phone"
               className="flex items-center gap-3 text-cream hover:text-ember transition-colors">
              <Phone size={16} /> <span className="text-sm tracking-wider">{BRAND.phone}</span>
            </a>
            <a href={BRAND.emailHref} data-testid="footer-email"
               className="flex items-center gap-3 text-cream hover:text-ember transition-colors">
              <Mail size={16} /> <span className="text-sm tracking-wider">{BRAND.email}</span>
            </a>
            <a href={BRAND.instagramUrl} target="_blank" rel="noreferrer" data-testid="footer-instagram"
               className="flex items-center gap-3 text-cream hover:text-ember transition-colors">
              <Instagram size={16} /> <span className="text-sm tracking-wider">{BRAND.instagram}</span>
            </a>
          </div>

          <div className="md:col-span-3 space-y-3">
            <p className="text-[10px] uppercase tracking-[0.3em] text-cream/60">Wander</p>
            <ul className="space-y-2 font-serif text-xl">
              <li><Link to="/menu" className="hover:text-ember transition-colors">Menu</Link></li>
              <li><Link to="/gallery" className="hover:text-ember transition-colors">Gallery</Link></li>
              <li><Link to="/locations" className="hover:text-ember transition-colors">Locations</Link></li>
              <li><Link to="/reserve" className="hover:text-ember transition-colors">Reserve</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-cream/15 flex flex-col md:flex-row justify-between gap-4 text-xs text-cream/55 tracking-wider">
          <p>© {new Date().getFullYear()} Old Soul Pizzeria. Crafted slow, served warm.</p>
          <p className="uppercase tracking-[0.25em]">Scarborough, ON · Vegetarian & Vegan</p>
        </div>
      </div>
    </footer>
  );
}
